import {
  ABOUT,
  ABOUT_CONTENT,
  ABOUT_CONTENT_RAW,
  LINKS,
  IMAGES,
  IMAGES_PREVIEW,
  OPEN,
  EDIT,
  CUSTOM,
  SELECT_TOOLBAR,
 } from '../constants';

const initialStateabout = {
  content: '',
  rawcontent: `{"blocks":[{"key":"5le0v","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":11,"style":"BOLD"},{"offset":81,"length":6,"style":"ITALIC"}],"entityRanges":[{"offset":75,"length":5,"key":0}],"data":{}}],"entityMap":{"0":{"type":"LINK","mutability":"MUTABLE","data":{"url":"hyhyhyhy"}}}}`
}
export const about = (state=initialStateabout, action={}) => {
  switch (action.type) {
    case ABOUT_CONTENT:
      return Object.assign({}, state, {content: action.payload})
    case ABOUT_CONTENT_RAW:
      return Object.assign({}, state, {rawcontent: action.payload})
    case ABOUT:
      return Object.assign(state, action.payload)
    default:
      return state
  }
}

const initialStateimagesPreview = []

export const imagesPreview = (state=initialStateimagesPreview, action={}) => {
  switch (action.type) {
    case IMAGES_PREVIEW:
      return Object.assign([], state, action.payload)
    default:
      return state
  }
}

const initialStateimages = []

export const images = (state=initialStateimages, action={}) => {
  switch (action.type) {
    case IMAGES:
      return Object.assign([], state, action.payload)
    default:
      return state
  }
}

const initialStatelinks = []

export const links = (state=initialStatelinks, action={}) => {
  switch (action.type) {
    case LINKS:
      return Object.assign([], state, action.payload)
    default:
      return state
  }
}

const initialStateActivities = {
  open: '',
  edit: true
}

export const activities = (state=initialStateActivities, action={}) => {
  switch (action.type) {
    case OPEN:
      return Object.assign({}, state, {open: action.payload})
    case EDIT:
      return Object.assign({}, state, {edit: action.payload})
    default:
      return state
  }
}

const initialStateCustomization = {
      custom: [{font: 'roboto', size: '16', color: '#000', class: 'profile_name'}, {font: 'roboto', size: '14', color: '#ccc', class: 'profile_bio'}, {font: 'roboto', size: '14', color: '#000', class: 'about'}, {color: '#000', class: 'icons'}, {color: '#fff', opacity: '1', class: 'background'}],
      select: ''
  }

export const customization = (state=initialStateCustomization, action={}) => {
  switch (action.type) {
    case CUSTOM:
      return Object.assign({}, state, {custom: action.payload})
    case SELECT_TOOLBAR:
      return Object.assign({}, state, {select: action.payload})
    default:
      return state
  }
}